import { render, staticRenderFns } from "./Marcas.vue?vue&type=template&id=0a971ce6&scoped=true&"
import script from "./Marcas.vue?vue&type=script&lang=js&"
export * from "./Marcas.vue?vue&type=script&lang=js&"
import style0 from "./Marcas.vue?vue&type=style&index=0&id=0a971ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a971ce6",
  null
  
)

export default component.exports